import { css } from "@emotion/react";
import tokens from "@kibela/design-tokens";

import { size } from "~/client/styles/emotion/mixins/size";

export const style = (read: boolean) => {
  return css({
    ...size("8px"),
    opacity: read ? 0 : 1,
    display: "inline-block",
    borderRadius: "50%",
    background: tokens.color.symbol.alert.value,
    flexShrink: 0,
  });
};
